// extracted by mini-css-extract-plugin
module.exports = {"label":"styles_label__1Iyvi","menu":"styles_menu__eFmse","checkbox":"styles_checkbox__1i-ub","formLabel":"styles_formLabel__1g3Tw"};